import { render, staticRenderFns } from "./GuidelinePreviousVersionsView.vue?vue&type=template&id=c81febe2&scoped=true&"
import script from "./GuidelinePreviousVersionsView.vue?vue&type=script&lang=js&"
export * from "./GuidelinePreviousVersionsView.vue?vue&type=script&lang=js&"
import style0 from "./GuidelinePreviousVersionsView.vue?vue&type=style&index=0&id=c81febe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81febe2",
  null
  
)

export default component.exports